import { render } from "./Key5.vue?vue&type=template&id=dcdbd6e8"
import script from "./Key5.vue?vue&type=script&lang=ts"
export * from "./Key5.vue?vue&type=script&lang=ts"
script.render = render

export default script